import React, {useEffect, useState } from "react";
import socket from '../../socket';

/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

/// Components
import Mentions from "../components/chatBox/Mentions.js";
import Chat from "../components/chatBox/Chat";
import { Link } from "react-router-dom";

const ChatBox = ({ onClick, toggle, setNotifications }) => {
   const [toggleTab, settoggleTab] = useState(
      window.location.hash.slice(1) ? window.location.hash.slice(1) : "chat"
   );

   const dataToggle = [
      { href: "#chat", name: "Chat" },
      { href: "#mentions", name: "Mentions" },
   ];

   const userDetails = JSON.parse(localStorage.getItem('userDetails'));
   const username = userDetails.idToken.payload['cognito:username']

   useEffect(() => {
      socket.connect()

      socket.on("connected", () => {
         socket.emit('register', username)
         socket.emit('retrieveMsgs', username)
         socket.emit('mentions', username)
       });

       socket.on("registered", () => {
       })
   }, [username])

   return (
      <div className={`chatbox ${toggle === "chatbox" ? "active" : ""}`}>
         <div className="chatbox-close" onClick={() => onClick()}></div>
         <div className="custom-tab-1">
            <ul className="nav nav-tabs">
               {dataToggle.map((data, i) => (
                  <li className="nav-item" key={i}>
                     <Link
                        className={`nav-link ${
                           toggleTab === data.name.toLocaleLowerCase()
                              ? "active"
                              : ""
                        }`}
                        to="#"
                        data-toggle="tab"
                        href={data.href}
                        onClick={() =>
                           settoggleTab(data.name.toLocaleLowerCase())
                        }
                     >
                        {data.name}
                     </Link>
                  </li>
               ))}
            </ul>
            <div className="tab-content">
               <Chat
                  PerfectScrollbar={PerfectScrollbar}
                  toggle={toggle}
                  toggleTab={toggleTab}
                  socket={socket}
                  setNotifications={setNotifications}
               />
               <Mentions
                  PerfectScrollbar={PerfectScrollbar}
                  toggle={toggle}
                  socket={socket}
                  toggleTab={toggleTab}
               />
            </div>
         </div>
      </div>
   );
};

export default ChatBox;
